import http from '../../../service/axios';
import { ICreateAddress } from '../types/Adresses';
import { INearbyBranchResponse } from '../types/NearestBranch';
import {
  GeoCode,
  OsmReverseResponse,
  OsmSearchResponse,
} from '../types/GeoCode';
import axios from 'axios';

const osm = axios.create({
  baseURL: 'https://nominatim.openstreetmap.org',
});

/** Страны, по которым ищем адреса: доставка работает только в Узбекистане. */
const SEARCH_COUNTRY_CODES = 'uz';
/** Полградуса вокруг точки на карте — примерно город с пригородами. */
const SEARCH_VIEWBOX_DELTA = 0.2;

export const addressesAPI = {
  getUserAddress: async ({ lat, lng }: GeoCode) => {
    const res = await osm.get<OsmReverseResponse>('/reverse', {
      params: {
        format: 'jsonv2',
        lat,
        lon: lng,
      },
    });
    return res;
  },
  /**
   * Поиск адреса.
   *
   * `countrycodes` — потому что доставляем только по Узбекистану: без него
   * «Пушкина» отдавала пять улиц в России, а ташкентской в выдаче не было
   * вовсе. `viewbox` смещает выдачу к точке на карте (без `bounded`, так что
   * адреса из других городов остаются — просто ниже).
   */
  searchAddresses: async (
    query: string,
    options?: { center?: { lat: number; lng: number }; language?: string }
  ) => {
    const center = options?.center;

    const res = await osm.get<OsmSearchResponse>('/search', {
      params: {
        format: 'jsonv2',
        q: query,
        addressdetails: 1,
        limit: 10,
        countrycodes: SEARCH_COUNTRY_CODES,
        // Имена улиц и городов на языке приложения: по умолчанию OSM отдаёт
        // местные латинские названия («Toshkent shahri»).
        'accept-language': options?.language || 'ru',
        ...(center
          ? {
              viewbox: [
                center.lng - SEARCH_VIEWBOX_DELTA,
                center.lat + SEARCH_VIEWBOX_DELTA,
                center.lng + SEARCH_VIEWBOX_DELTA,
                center.lat - SEARCH_VIEWBOX_DELTA,
              ].join(','),
            }
          : {}),
      },
    });
    return res;
  },
  getNearBranch: async (lat: number, lng: number) =>
    await http.get<INearbyBranchResponse>('/branch/nearby', {
      params: {
        company_id: 1,
        latLong: `${lat},${lng}`,
      },
    }),

  getAddresses: async () => await http.get('/user/addresses'),
  createAddress: async (body: ICreateAddress) =>
    await http.post('/user/save-address', body),
  editAddress: async (body: ICreateAddress, id: string) =>
    await http.post(`/user/save-address`, { ...body, id }),
  deleteAddress: async (id: string) =>
    await http.get(`/user/delete-address?id=${id}`),
};
